var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocial = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "social_svg__icon social_svg__icon-tabler social_svg__icons-tabler-outline social_svg__icon-tabler-social"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 5a2 2 0 1 0 4 0 2 2 0 1 0-4 0M3 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0M17 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0M9 14a3 3 0 1 0 6 0 3 3 0 1 0-6 0M12 7v4M6.7 17.8l2.8-2M17.3 17.8l-2.8-2"
})));
export default SvgSocial;